import React, { useContext, useEffect, useState } from 'react';
import CartHeader from '../../ShoppingCart/CartHeader';
import { AddressForm } from '../AddressForm';
import { CartContext } from '../../../Context/CartContext';
import { ContentfulContext } from '../../../Context/Contentful';
import { TextInput } from 'dw-au-react-components';
import CartItems from '../../ShoppingCart/CartItems';
import styled from '@emotion/styled';

const StyledGuestDetailsForm = styled.div`
	.cart__wrapper {
		min-height: calc(100vh - 120px);
	}
`;

function GuestDetailsForm({
	handleFormSubmission,
	defaultValues,
	step,
	setStep,
	onEmailValidation,
	allowExistingCustomer,
	setLoginEmail,
	checkEmailExistance,
}) {
	const {
		cartData,
		removeFromCart,
		handleToggleCart,
		guestShipping,
		setGuestShipping,
		voucherPopupEmail,
		setVoucherPopupEmail,
	} = useContext(CartContext);
	const { freeItem } = useContext(ContentfulContext);

	const [emailCheck, setEmailCheck] = useState(null);
	const [emailError, setEmailError] = useState(false);
	const [newEmail, setNewEmail] = useState(
		voucherPopupEmail ? voucherPopupEmail : null
	);

	const validateEmail = (inputValue) => {
		const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/;
		return emailRegex.test(inputValue);
	};

	const tempEmailChangeHandler = (event) => {
		setEmailError(false);
		if (validateEmail(event.target.value)) {
			setEmailCheck(event.target.value);
			setNewEmail(event.target.value);
		} else {
			setEmailError(true);
			setEmailCheck(null);
		}
	};

	const cancelCta = (
		<div
			className='btn btn-outline-secondary btn-block'
			onClick={() => {
				setStep(0);
			}}
		>
			Go back to your Cart
		</div>
	);

	useEffect(() => {
		if (!allowExistingCustomer) {
			setGuestShipping(true);
		}
	}, [allowExistingCustomer]);

	useEffect(() => {
		if (voucherPopupEmail) {
			setEmailCheck(voucherPopupEmail);
			setVoucherPopupEmail(null);
		}
	}, [voucherPopupEmail]);

	return (
		<StyledGuestDetailsForm>
			<CartHeader
				title='Checkout'
				step={step}
				setStep={setStep}
				cartData={cartData}
			/>

			{cartData.length > 0 ? (
				<>
					<div className='mb-30'>
						<div className='subtitle'>Your Cart</div>
						{cartData.map((item, index) => {
							let { itemCode, product } = item;
							return (
								<CartItems
									key={index}
									itemCode={itemCode}
									cartItem={product}
									removeFromCart={removeFromCart}
								/>
							);
						})}

						{freeItem && (
							<CartItems
								itemCode={freeItem?.itemCode}
								cartItem={freeItem}
								removeFromCart={removeFromCart}
								freeItem={true}
							/>
						)}
					</div>

					{guestShipping ? (
						<>
							<div className='subtitle mb-16 lower roboto'>
								Looks like you&#39;re new here. Enter your personal details
								below.
							</div>
							{allowExistingCustomer && (
								<p
									className='mb-16'
									onClick={() => {
										setGuestShipping(false);
										setEmailCheck(null);
									}}
								>
									Not you?{' '}
									<span className='d-inline-block cursor-pointer'>
										<u>Use another email</u>
									</span>
									.
								</p>
							)}
						</>
					) : (
						<div className='subtitle roboto lower mb-16'>
							Enter your email address to continue to delivery and payment.
						</div>
					)}
					{!guestShipping ? (
						<>
							<div className='mb-16'>
								<TextInput
									type='email'
									label='Email'
									onChange={tempEmailChangeHandler}
									error={emailError}
									defaultValue={newEmail}
									helperText={
										emailError ? 'Please enter a valid email address.' : ''
									}
								/>
							</div>
							<button
								type='button'
								disabled={!emailCheck}
								onClick={() => checkEmailExistance(emailCheck)}
								className={
									'btn btn-primary font-weight-bold dmlp__btn w-100 mb-20 dmlp_email_continue_button'
								}
							>
								Continue
							</button>
							{/* {cancelCta} */}
						</>
					) : (
						<AddressForm
							handleFormSubmission={handleFormSubmission}
							defaultValues={
								emailCheck
									? { ...defaultValues, email: newEmail }
									: defaultValues
							}
							setStep={setStep}
							onEmailValidation={onEmailValidation}
							allowExistingCustomer={allowExistingCustomer}
							guestShipping={guestShipping}
							setGuestShipping={setGuestShipping}
							setLoginEmail={setLoginEmail}
							setEmailCheck={setEmailCheck}
						/>
					)}
				</>
			) : (
				<div className='d-flex flex-column cart__wrapper'>
					<div className='dmlp__cart__empty'>
						<h4 className='mt-0 mb-20'>Your shopping cart is empty.</h4>
						<div>
							<button
								type='button'
								className='btn btn-primary-outline btn-outline-primary dmlp__btn'
								onClick={handleToggleCart}
							>
								Continue Shopping
							</button>
						</div>
					</div>
				</div>
			)}
		</StyledGuestDetailsForm>
	);
}

export default GuestDetailsForm;
